import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Loader.scss';

export class Loader extends Component {
	static propTypes = {
		fullScreen: PropTypes.bool,
		inline: PropTypes.bool,
		center: PropTypes.bool,
		cart: PropTypes.bool,
	};

	static defaultProps = {
		fullScreen: false,
		inline: false,
		center: false,
		cart: false,
	};

	render() {
		const fullScreenClass = this.props.fullScreen ? 'FullScreen' : '';
		const inline = this.props.inline ? 'Inline' : '';
		const cart = this.props.cart ? 'CartLoader' : '';

		return (
			<div className="Loader">
				<div
					className={`SpinnerContainer ${inline} ${fullScreenClass} ${cart}`}
				>
					<div className="Spinner" />
				</div>
			</div>
		);
	}
}

export default Loader;



// WEBPACK FOOTER //
// ./src/ui/components/Loader/index.js